import { PdpDocumentsDTO } from '@/types/models';
import { client } from '@/api/client';
export const getPdpDocuments = async (id: string): Promise<PdpDocumentsDTO> => {
  try {
    const result = await client.get(`/plans/${id}/documents`);
    return result.data.data;
  } catch (error) {
    return {} as PdpDocumentsDTO;
  }
};
export const pdpDocumentsOptions = (id: string) => {
  return {
    queryKey: ['pdp-documents', id],
    queryFn: () => getPdpDocuments(id)
  };
};